import type { NavigationItemType } from "../../../root/layout/SidebarMenuItem";
import type { Paths } from "../../../shared/usePrivacyNavigate";
import { TemplatePage } from "./TemplateFormPage";
import { prefetchTemplateFormTypes } from "../../../api/templateFormSettings";

export const route: NavigationItemType["route"] = { path: "templates/*", element: <TemplatePage /> };

export const to = (paths: Paths) => paths.templateForms();
export const prefetch = prefetchTemplateFormTypes;
